<template>
  <BNavItemDropdown right no-caret>
    <template v-slot:button-content>
      <bell-icon v-if="no_notifications"></bell-icon>
      <bell-ring-icon
        v-if="!no_notifications"
        fillColor="#5cb85c"
      ></bell-ring-icon>
      <BBadge pill variant="success" v-if="!no_notifications">{{
        number_of_unread
      }}</BBadge>
    </template>
    <BDropdownHeader id="dropdown-header-label">
      <span class="d-flex justify-content-between">
        <span class="font-weight-bold text-secondary pr-5">Notifications</span>
        <span class="d-flex">
          <BLink @click.prevent="hide_read">Hide all read</BLink>
          <span class="mx-1">&#8226;</span>
          <BLink @click.prevent="mark_all_read">Mark all as read</BLink>
        </span>
      </span>
    </BDropdownHeader>
    <BDropdownText
      v-if="no_notifications"
      class="d-flex flex-column text-center pt-4 pb-3 border-top"
    >
      <bell-off-outline-icon class="icon-2x text-secondary" />
      <p class="mb-0 mt-1">You have no notifications yet.</p>
    </BDropdownText>
    <li v-if="format_notification.length > 0">
      <ul class="notification-list p-0">
        <BDropdownItemButton
          v-for="notification in format_notification"
          :key="notification.id"
          @click="click(notification)"
          class="border-top"
        >
          <span class="d-flex flex-column text-wrap">
            <span :class="calc_class(notification)" class="pt-2">{{
              notification.description
            }}</span>
            <span>{{ notification.subline }}</span>
            <BButtonGroup size="sm" v-if="showButtonOnDropdown(notification)">
              <BButton
                class="mt-1"
                v-for="btn in notification.buttons"
                :key="btn.id"
                :variant="getStyle(btn, notification.button_selected)"
                :class="{ disabled: !!notification.button_selected }"
                block
                @click="click_button(notification, btn)"
                >{{ btn.button_text }}</BButton
              >
            </BButtonGroup>
            <span class="text-secondary text-right mt-1 whensent">{{
              createdDate(notification)
            }}</span>
          </span>
        </BDropdownItemButton>
      </ul>
    </li>

    <BDropdownDivider />
    <li class="text-center">
      <BLink :to="notification_inbox_link"> See all notifications </BLink>
    </li>

    <BModal ref="my-modal" hide-footer title="Notification">
      <div class="d-block text-center">
        {{ dialog_notification.description }}
      </div>
      <BButton
        class="mt-3"
        v-for="btn in dialog_notification.buttons"
        :key="btn.id"
        :variant="btn.style"
        block
        @click="click_button(dialog_notification, btn)"
        >{{ btn.button_text }}</BButton
      >
    </BModal>
  </BNavItemDropdown>
</template>
<script>
import {
  BBadge,
  BButton,
  BButtonGroup,
  BDropdownDivider,
  BDropdownHeader,
  BDropdownItemButton,
  BDropdownText,
  BLink,
  BModal,
  BNavItemDropdown,
} from "bootstrap-vue";
import BellIcon from "vue-material-design-icons/Bell.vue";
import BellRingIcon from "vue-material-design-icons/BellRing.vue";
import BellOffOutlineIcon from "vue-material-design-icons/BellOffOutline.vue";
import { CreateListPageMixin, UseRestModuleMixin } from "../../vue-ocom/mixins";
import _ from "lodash";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import * as CONFIG from "../../config.js";

const Centrifuge = require("centrifuge");

export default {
  name: "Notification",
  components: {
    BNavItemDropdown,
    BBadge,
    BDropdownHeader,
    BLink,
    BDropdownText,
    BDropdownItemButton,
    BButtonGroup,
    BButton,
    BDropdownDivider,
    BModal,
    BellIcon,
    BellRingIcon,
    BellOffOutlineIcon,
  },
  mixins: [
    CreateListPageMixin("UserNotification", "user_notification"),
    UseRestModuleMixin(["UserNotification"]),
  ],
  props: {
    tableInline: {
      type: Boolean,
      default: true /* Change from CreateListPageMixin so it doesnt change route */,
    } /* When true doesn't update route */,
  },
  data() {
    return {
      timer: null,
      dialog_notification: { buttons: [], description: "" },
      notification_inbox_link: {
        name: "notification.inbox",
        query: {
          limit: 10,
          filter: "all",
          sort: "created_date",
          order: "desc",
        },
      },
    };
  },
  methods: {
    ...mapActions("UserNotificationModule", ["patchItem"]),
    ...mapActions({
      notification_getAll: "UserNotificationModule/getAll",
      saveUserNotificationItem: "UserNotificationModule/saveItem",
    }),
    click_button(notification, button_clicked) {
      this.patchItem({
        id: notification.id,
        button_selected: button_clicked.id,
        read: new Date(),
      });
      // Make local Read and Selected.
      notification.read = new Date();
      notification.button_selected = button_clicked.id;

      if (button_clicked.url) {
        var url = button_clicked.url;
        if (!url.startsWith("http")) {
          url = window.location.origin + url;
        }
        window.location.href = url;
      } else {
        this.$refs["my-modal"].hide(); // Done!
      }
    },
    getStyle(btn, button_selected) {
      if (button_selected) {
        if (btn.id !== button_selected) {
          return "outline-" + btn.style;
        }
      }

      return btn.style;
    },
    click(notification) {
      if (notification.buttons.length === 1) {
        this.click_button(notification, notification.buttons[0]);
      } else if (notification.buttons.length === 0) {
        this.dialog_notification = notification;
        this.$refs["my-modal"].show();
      }
    },
    hide_read() {
      const vm = this;

      _.forEach(this.active_notifications, function (item) {
        if (item.read) {
          item.hide = true;
          vm.patchItem({ id: item.id, hide: true });
        }
      });
    },
    mark_all_read() {
      const vm = this;

      _.each(this.can_be_marked_all_as_read, (item) => {
        const button_id =
          item.notification_set[0].buttons.length > 0
            ? item.notification_set[0].buttons[0].id
            : null;

        if (!item.read) {
          item.read = new Date();
          item.button_selected = button_id;
          vm.patchItem({
            id: item.id,
            button_selected: button_id,
            read: item.read,
          });
        }
      });
    },
    calc_class(notification) {
      const result = {};
      if (!notification.read) {
        result["unread"] = true;
      } else {
        result["read"] = true;
      }

      return result;
    },
    reload() {
      this.update_table({ limit: 25, filter: "all" });
    },
    connect() {
      if (this.isLoggedIn) {
        // Initialize
        var url = CONFIG.CentAPI;

        if (url.startsWith("wss:///")) {
          // ie production then build from URL
          var schema = "ws://";
          if (window.location.protocol === "https:") {
            schema = "wss://";
          }
          url = url.replace("wss:///", schema + location.host + "/");
        }

        var centrifuge = new Centrifuge(url);

        centrifuge.setToken(this.token);

        // On connect
        centrifuge.on("connect", function (ctx) {
          console.log("connected", ctx);
        });

        // On disconnect
        centrifuge.on("disconnect", function (ctx) {
          console.log("disconnected", ctx);
        });

        // Subscribe
        var vm = this;
        const channel_name =
          "notification_" + this.currentUser.id + "#" + this.currentUser.id;

        centrifuge.subscribe(channel_name, function (ctx) {
          vm.items.push(ctx.data);
        });

        // Connect
        centrifuge.connect();
      }
    },
  },
  computed: {
    ...mapGetters({
      token: "AuthModule/token",
      isLoggedIn: "AuthModule/isLoggedIn",
      currentUser: "AuthModule/currentUser",
    }),
    number_of_unread() {
      return _.filter(this.active_notifications, function (item) {
        // fitler
        return item.read == null;
      }).length;
    },
    number_of_notifications() {
      return this.active_notifications.length;
    },
    no_notifications() {
      return this.number_of_unread < 1;
    },
    active_notifications() {
      return _.filter(this.items, function (item) {
        // filter
        return item.notification_set.length > 0 && item.hide === false;
      });
    },
    can_be_marked_all_as_read() {
      return _.filter(this.items, (item) => {
        return item.notification_set[0].buttons.length <= 1;
      });
    },
    format_notification() {
      //Simplify the object
      const mapped_notifications = _.map(
        this.active_notifications,
        function (item) {
          var notification = item.notification_set[0];
          var result = {
            ...item,
            description: notification.description,
            subline: notification.subline,
            buttons: notification.buttons,
          };
          delete result.notification_set;

          return result;
        }
      );

      return _.orderBy(mapped_notifications, "created_date", "desc"); // newest first
    },
    createdDate() {
      return (notification) => {
        if (notification.created_date) {
          return moment(notification.created_date).fromNow();
        }

        return;
      };
    },
    showButtonOnDropdown() {
      return (notification) => {
        return (
          notification.buttons.length > 0 && notification.buttons.length < 3
        );
      };
    },
  },
  created() {
    this.reload(); // Load inital data when component created

    // Get recent notifications after login
    let options = {
      filter: "by_user",
      offset: 0,
      limit: 10000,
      sort: "notification_date",
      order: "desc",
    };
    this.notification_getAll(options);

    if (CONFIG.CentAPI) {
      // Use websockets if configured
      this.connect();
    } else {
      // Fallback to ajax every 25 seconds
      this.timer = window.setInterval(this.reload, 25 * 1000); // 25 seconds
    }
  },
  beforeDestroy() {
    window.clearInterval(this.timer);
  },
};
</script>
<style>
.unread {
  font-weight: bold;
}

.read {
  color: #807f7f;
}

.whensent {
  font-size: smaller;
}

.notification-list {
  max-height: 350px;
  overflow-y: auto;
  list-style: none;
}

.notification-list::-webkit-scrollbar {
  width: 12px;
}

.notification-list::-webkit-scrollbar-track {
  border-radius: 0 4px 4px 0;
  background-color: #f6f6f6;
  border: 1px solid #eff0f1;
}

.notification-list::-webkit-scrollbar-thumb {
  border-radius: 20px;
  scrollbar-width: thin;
  background-color: rgba(55, 66, 73, 0.4);
  border: 3px solid #f6f6f6;
}

.notification-list {
  scrollbar-width: thin;
  scrollbar-color: rgba(55, 66, 73, 0.4);
}

.material-design-icon.icon-2x {
  height: 2em;
  width: 2em;
}

.material-design-icon.icon-2x > .material-design-icon__svg {
  height: 2em;
  width: 2em;
}
</style>
